import Page from '../../Page';
import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Box, Container, IconButton, Skeleton, Stack, Chip, Typography, Button, Dialog, DialogContent, TextField, MenuItem, Autocomplete, Modal, Drawer, Stepper, Step, StepLabel, StepContent, Tabs, Tab, Checkbox, FormControlLabel, CircularProgress, Divider, InputAdornment, List, ListItem, ListItemText, Grid, Card, Tooltip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Close, Download, Update, Clear, Edit, Delete, Send, Schedule, CloudUpload, CheckCircle, Search } from '@mui/icons-material';
import * as constants from 'src/utils/constants';
import { showToast, showErrorToast } from 'src/utils/Toast/SnackbarProvider';
import { getDDMonthYYYYFormat } from 'src/utils/commonUtils';
import apiInstance from 'src/utils/apiAuth';
import CalendarRangePicker from 'src/components/CalendarRangePicker';
import axios from 'axios';
import TextEditor from 'src/components/TextEditor';
import { useMediaQuery } from '@mui/material';


const theme = createTheme({
    components: {
        MUIDataTable: {
            styleOverrides: {
                root: {
                    backgroundColor: '#red',
                },
                paper: {
                    boxShadow: 'none',
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    // backgroundColor: 'yellow',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    backgroundColor: '#f5f5f5',
                    borderBottom: '2px solid #e0e0e0',
                    fontWeight: '600',
                    color: '#333',
                    '& .MuiTableCell-content': {
                        textAlign: 'center',
                    },
                },
                // Center align the header cell content
                root: {
                    '&.MuiTableCell-head': {
                        textAlign: 'center',
                    }
                }
            },
        },
        MUIDataTableHeadCell: {
            styleOverrides: {
                root: {
                    fontWeight: '600',
                    backgroundColor: '#f5f5f5',
                    borderBottom: '2px solid #e0e0e0',
                    color: '#333',
                },
                data: {
                    fontWeight: '600',
                    textAlign: 'center', // Center align the header text
                    color: '#333',
                },
                contentWrapper: {
                    justifyContent: 'center', // Center the entire content wrapper
                },
                sortActive: {
                    color: 'inherit',
                },
                fixedHeader: {
                    textAlign: 'center',
                    '& .MuiTableCell-root': {
                        textAlign: 'center',
                    }
                }
            }
        },
        MUIDataTableSelectCell: {
            styleOverrides: {
                headerCell: {
                    // backgroundColor: 'blue',
                    fontWeight: '500px'
                },
            },
        },
        MuiTableFooter: {
            styleOverrides: {
                root: {
                    '& .MuiToolbar-root': {
                        //   backgroundColor: 'purple',
                    },
                },
            },
        },
    },
    typography: {
        fontFamily: "Lexend"
    }
});

const components = {
    ExpandButton: function (props) {
        return <ExpandButton {...props} />;
    }
};

const decodeHtml = (html) => {
    if (!html) return '';
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};

export default function BulkOutreach() {
    const [isLoading, setIsLoading] = useState(true)
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedDateRange, setSelectedDateRange] = useState(() => {
        const end = new Date();
        const start = new Date();
        start.setDate(end.getDate() - 8);
        return [start.toISOString().split('T')[0], end.toISOString().split('T')[0], 'created'];
    });
    const [filterParams, setFilterParams] = useState(null);
    const [sortOrder, setSortOrder] = useState();
    const [count, setCount] = useState(null);

    const matches = useMediaQuery('(max-width:900px)');

    // Function to append filters to the URL
    const applyFiltersToUrl = (filterParams) => {
        let url = "";

        // use filterParams to filter the data using the API
        for (const key in filterParams) {
            if (filterParams[key] && Array.isArray(filterParams[key]) && filterParams[key].length > 0) {
                url += `${key}=${filterParams[key].join(",")}&`;
            }
        }
        return url;
    };


    const [userData, setUserData] = useState([]);
    const getUserData = () => {
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/users-viewset?short_details=${true}`;
        apiInstance.get(apiUrl, { headers: { Authorization: `Token ${localStorage.getItem("authToken")}` } })
            .then((response) => {
                let userData = response?.data?.data?.map((item) => ({
                    id: item.pk,
                    user: item.first_name + " " + item.last_name,
                }));
                setUserData(userData || []);
            })
            .catch((e) => console.log("something went wrong :(", e));
    };

    const [senderDetails, setSenderDetails] = useState([]);
    const getSenderDetails = () => {
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/sender-details?`;

        apiInstance.get(apiUrl, { headers: { "Authorization": `Token ${localStorage.getItem('authToken')}` } })
            .then((response) => {
                setSenderDetails(response?.data?.data?.filter(obj => obj?.is_active));
            })
            .catch((e) => showErrorToast(e));
    };

    const [stageData, setStageData] = useState([]);
    const getStageData = () => {
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/company/get_stage_names`;
        axios.get(apiUrl, { headers: { Authorization: `Token ${localStorage.getItem("authToken")}` } })
            .then((response) => {
                let stages = response?.data?.data
                    ?.map((item) => ({
                        id: item.stage_id,
                        stage: item.stage_name
                    }));
                setStageData(stages || []);
            })
            .catch((e) => console.log("something went wrong :(", e));
    };

    const [countryData, setCountryData] = useState([]);
    const getCountryData = () => {
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/location?company_added=${true}`;
        axios
            .get(apiUrl, { headers: { Authorization: `Token ${localStorage.getItem("authToken")}` } })
            .then((response) => {
                let countryData = response?.data?.data
                    ?.filter((item) => item.is_active)
                    ?.map((item) => ({
                        id: item.id,
                        country: item.label,
                    }));
                setCountryData(countryData || []);
            })
            .catch((e) => console.log("something went wrong :(", e));
    };

    const options = {
        selectableRows: "none",
        filterType: "multiselect",
        download: false,
        filter: false,
        viewColumns: false,
        setFilterChipProps: (colIdx, colName, data) => {
            const column = columns.find(col => col.name === colName);
            const label = column ? column.label : colName; // Fallback to colName if no label is found

            return {
                label: `${label}: ${data}`,
            };
        },
        responsive: "standard",
        draggableColumns: { enabled: true },
        print: false,
        page: currentPage,
        serverSide: true,
        count: count,
        search: false,
        rowsPerPage: rowsPerPage,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setCurrentPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setRowsPerPage(tableState.rowsPerPage);
                    break;
                case 'sort':
                    setSortOrder(tableState.sortOrder);
                    break;
                default:
                    break;
            }
        },
        onFilterChange: (column, filterList, type) => {
            const index = columns.findIndex((item) => item.name === column);
            const filterValue = filterList[index];

            const mapFilterValueToIds = (data, property = "name") => {
                return filterValue.length > 0
                    ? filterValue.map((item) => data.find((entry) => entry[property] === item).id)
                    : [];
            };

            setCurrentPage(0);

            let newFilterParams = { ...filterParams };

            switch (column) {
                case 'campaign_status':
                    newFilterParams.status = filterValue;
                    break;
                case 'created_by':
                    newFilterParams.created_by = mapFilterValueToIds(userData, "user")
                    break;
                case null:
                    newFilterParams = {};
                    break;
                default:
                    break;
            }

            // Remove the property if it has no value
            if (newFilterParams[column] && newFilterParams[column].length === 0) {
                delete newFilterParams[column];
            }

            setFilterParams(newFilterParams);
        },
    };
    
    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                filter: false,
                display: false,
            },
        },
        {
            name: "campaign_details",
            label: "Campaign",
            options: {
                filter: false,
                customBodyRender: (value) => {
                    return  <Box minWidth="20vw">
                                <Stack spacing={0.5}>  
                                    <Typography variant="body2"><b>{value?.campaign_name}</b></Typography>
                                    <Typography variant="body2" color="#768796">{value?.campaign_subject ? `Subject: ${value?.campaign_subject}` : null}</Typography>
                                    <Typography variant="body2" color="#768796">{value?.sender ? `Sender: ${value?.sender}` : null}</Typography>
                                    <Typography variant="body2" color="#768796">{value?.campaign_date ? `${getDDMonthYYYYFormat(value?.campaign_date)}` : null}</Typography>
                                    {value?.scheduled_date && (
                                        <Typography variant="body2" color="#e65100" fontWeight={600}>
                                            Scheduled: {new Date(value.scheduled_date).toLocaleString()}
                                        </Typography>
                                    )}
                                    {value?.recipient_count != null && (
                                        <Typography variant="body2" color="#388e3c" fontWeight={600}>Recipients: {value.recipient_count} companies</Typography>
                                    )}
                                </Stack>
                            </Box>
                }
            },
        },
        {
            name: "campaign_status",
            label: "Status",
            options: {
                filter: true,
                filterOptions: {
                    fullWidth: true,
                    names: ["triggered", "scheduled", "draft"]
                },
                customBodyRender: (value) => {
                    const getStatusStyle = (status) => {
                        switch (status) {
                            case "scheduled":
                                return { color: '#FF5C0E', backgroundColor: "#ffe3bf" };
                            case "triggered":
                                return { color: '#137f13', backgroundColor: "#d2f8d2" };
                            case "draft":
                                return { color: '#a01921', backgroundColor: "#fbe4e6" };
                            default:
                                return { color: 'inherit', backgroundColor: "transparent" };
                        }
                    };
        
                    return (
                        <Chip
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                ...getStatusStyle(value),
                            }}                            
                            label={value ? value[0].toUpperCase() + value.slice(1).toLowerCase() : '-'}
                        >
                        </Chip>
                    );
                },
            },
        },
        {
            name: "delivered",
            label: "Delivered",
            options: {
                filter: false
            },
        },
        {
            name: "invalid_emails",
            label: "Invalid Emails",
            options: {
                filter: false
            },
        },
        {
            name: "opens",
            label: "Opens",
            options: {
                filter: false
            },
        },
        {
            name: "unique_opens",
            label: "Unique Opens",
            options: {
                filter: false
            },
        },
        {
            name: "clicks",
            label: "Clicks",
            options: {
                filter: false
            },
        },
        {
            name: "unique_clicks",
            label: "Unique Clicks",
            options: {
                filter: false
            },
        },
        {
            name: "created_by",
            label: "Created By",
            options: {
                filter: true,
                display: false,
                filterOptions: {
                    fullWidth: true,
                    names: userData.map((item) => item.user),
                }
            }
        },
        {
            name: "actions",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => {
                    if (value?.isDraft) {
                        return (
                            <Stack spacing={1} direction="row" justifyContent="center" flexWrap="wrap">
                                <IconButton size="small" color="primary" title="Edit" onClick={() => handleEditCampaign(value.campaign)}>
                                    <Edit fontSize="small" />
                                </IconButton>
                                <IconButton size="small" color="error" title="Delete" onClick={() => handleDeleteCampaign(value.campaignId)}>
                                    <Delete fontSize="small" />
                                </IconButton>
                                <IconButton size="small" color="warning" title="Schedule" onClick={() => handleOpenScheduleDialog(value.campaignId)}>
                                    <Schedule fontSize="small" />
                                </IconButton>
                                <IconButton size="small" color="success" title="Send Now" onClick={() => handleSendCampaign(value.campaignId)}>
                                    <Send fontSize="small" />
                                </IconButton>
                            </Stack>
                        );
                    }
                    return (
                        <Stack spacing={1} direction="column" alignItems="stretch" justifyContent="center" flexWrap="wrap">
                            <Button
                                variant="outlined"
                                disabled={loadingId === value?.campaignId || !value?.singlesendId}
                                sx={{ m: 0.5 }}
                                onClick={() => getUpdatedStats(value?.statsId)}
                                startIcon={<Update />}
                                size="small"
                            >
                                Refresh
                            </Button>
                            <Button
                                variant="outlined"
                                color="info"
                                sx={{ m: 0.5 }}
                                onClick={() => getDetailedStats(value?.statsId)}
                                startIcon={<Search />}
                                size="small"
                            >
                                Details
                            </Button>
                            {value?.isDraft && (
                                <Button
                                    variant="outlined"
                                    color="error"
                                    disabled={loadingId === value?.campaignId}
                                    sx={{ m: 0.5 }}
                                    onClick={() => handleDeleteCampaign(value.campaignId, value?.campaign_status)}
                                    startIcon={<Delete />}
                                    size="small"
                                >
                                    Delete
                                </Button>
                            )}
                            {value?.isScheduled && (
                                <Button
                                    variant="outlined"
                                    color="error"
                                    sx={{ m: 0.5 }}
                                    onClick={() => handleCancelSchedule(value.campaignId)}
                                    startIcon={<Clear />}
                                    size="small"
                                >
                                    Cancel
                                </Button>
                            )}
                            {value?.isFailed && (
                                <Button
                                    variant="outlined"
                                    color="warning"
                                    sx={{ m: 0.5 }}
                                    onClick={() => handleRescheduleCampaign(value.campaignId)}
                                    startIcon={<Schedule />}
                                    size="small"
                                >
                                    Reschedule
                                </Button>
                            )}
                        </Stack>
                    );
                }
            }
        }
    ];

    const [statisticsData, setStatisticsData] = useState([]);
    const getStatisticsData = (page, pageSize = 10, selectedDateRange = [], filterParams = {}, sortOrder = null) => {
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/campaigns-stats?`;
        if (page + 1 && pageSize) apiUrl += `page=${page + 1}&page_size=${pageSize}&`;
        if (sortOrder && sortOrder?.name && sortOrder?.direction) apiUrl += `sortfield=${sortOrder.name}&sortdirection=${sortOrder.direction}&`;
        if (selectedDateRange.length > 0) apiUrl += `${selectedDateRange[0] ? `start_date=${selectedDateRange[0]}` : ''}${selectedDateRange[1] ? `&end_date=${selectedDateRange[1]}` : ''}${selectedDateRange[2] ? `&date_filter_type=${selectedDateRange[2]}&` : ''}`;
        
        // Append filters to the URL
        apiUrl += applyFiltersToUrl(filterParams);

        if (apiUrl.endsWith("&")) apiUrl = apiUrl.slice(0, -1);

        apiInstance.get(apiUrl, { headers: { "Authorization": `Token ${localStorage.getItem('authToken')}` } })
            .then((response) => {
                setStatisticsData(response?.data?.results?.data);
                setCount(response?.data?.count || 0);
            })
            .catch((e) => showErrorToast(e))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        getStatisticsData(currentPage, rowsPerPage, selectedDateRange, filterParams, sortOrder);
    }, [currentPage, rowsPerPage, selectedDateRange, filterParams, sortOrder]);

    useEffect(() => {
        getUserData();
        getSenderDetails();
        getStageData();
        getCountryData();
    }, []);

    const [isDownloading, setIsDownloading] = useState(null);
    const handleDownload = async (id) => {
        setIsDownloading(id);
    
        try {
            const apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/campaigns-stats/export-excel/`;

            const response = await apiInstance.post(apiUrl, {
                headers: { "Authorization": `Token ${localStorage.getItem('authToken')}` },
                responseType: 'blob',
                ids: id
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            // Extract filename from content-disposition header (if available)
            const contentDisposition = response.headers["content-disposition"];
            let filename = "sendgrid_export.csv"; // Default filename
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="(.+?)"/);
                if (match && match[1]) {
                    filename = match[1];
                }
            }

            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
    
            showToast("CSV downloaded successfully!");
        } catch (error) {
            showErrorToast("Error exporting CSV");
        } finally {
            setIsDownloading(null);
        }
    }

    const [loadingId, setLoadingId] = useState(null);
    const getUpdatedStats = (id) => {
        setLoadingId(id);
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/campaigns-stats/${id}/update-stats/`;
        apiInstance.put(apiUrl, {}, { 
            headers: { Authorization: `Token ${localStorage.getItem("authToken")}` } 
        })
        .then((response) => {
            showToast(response?.data?.message, 'success', 5000);
            window.location.reload(false);
        })
        .catch(function (error) {
            showErrorToast(error, null, 5000);
        })
        .finally(() => {
            setLoadingId(null);
        });
    }

    const getDetailedStats = (campaignId) => {
        setLoadingDetailedStats(true);
        setDetailedStatsOpen(true);
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/campaigns-stats/${campaignId}/detailed/`;
        apiInstance.get(apiUrl, { 
            headers: { Authorization: `Token ${localStorage.getItem("authToken")}` } 
        })
        .then((response) => {
            setDetailedStatsData(response?.data);
        })
        .catch(function (error) {
            showErrorToast(error, 'Failed to load detailed stats', 5000);
            setDetailedStatsOpen(false);
        })
        .finally(() => {
            setLoadingDetailedStats(false);
        });
    }

    const [isBulkDialogOpen, setIsBulkDialogOpen] = useState(false);
    const [bulkStages, setBulkStages] = useState([]); // store stage IDs
    const [bulkDateRange, setBulkDateRange] = useState([]);
    const [bulkSubject, setBulkSubject] = useState('');
    const [bulkBody, setBulkBody] = useState('');
    const [bulkSender, setBulkSender] = useState('');
    const [bulkCountries, setBulkCountries] = useState([]);
    const [bulkOutreachStatus, setBulkOutreachStatus] = useState('');
    const [bulkNewsletterStatus, setBulkNewsletterStatus] = useState('');
    const [bulkInvalidStatus, setBulkInvalidStatus] = useState('');
    const [isSendingBulk, setIsSendingBulk] = useState(false);
    const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState(false);
    const [isUploadingZip, setIsUploadingZip] = useState(false);
    const [zipFileName, setZipFileName] = useState('');
    const zipInputRef = useRef(null);
    const [activeStep, setActiveStep] = useState(0);
    const [editingCampaignId, setEditingCampaignId] = useState(null); // null = create mode, id = edit mode
    const [isScheduleDialogOpen, setIsScheduleDialogOpen] = useState(false);
    const [scheduleCampaignId, setScheduleCampaignId] = useState(null);
    const [scheduleDate, setScheduleDate] = useState('');
    const [detailedStatsOpen, setDetailedStatsOpen] = useState(false);
    const [detailedStatsData, setDetailedStatsData] = useState(null);
    const [loadingDetailedStats, setLoadingDetailedStats] = useState(false);
    const [recipientCompanies, setRecipientCompanies] = useState([]);
    const [recipientTotalCount, setRecipientTotalCount] = useState(0);
    const [recipientSearch, setRecipientSearch] = useState('');

    // Detailed stats table filters
    const [detailedRecipientSearch, setDetailedRecipientSearch] = useState('');
    const [detailedRecipientStatusFilter, setDetailedRecipientStatusFilter] = useState('all');
    const [detailedRecipientBouncedFilter, setDetailedRecipientBouncedFilter] = useState('all');
    const [detailedRecipientSpamFilter, setDetailedRecipientSpamFilter] = useState('all');
    const [recipientLoading, setRecipientLoading] = useState(false);
    const [recipientPage, setRecipientPage] = useState(1);
    const [recipientHasMore, setRecipientHasMore] = useState(false);
    const recipientListRef = useRef(null);
    const recipientDebounceRef = useRef(null);
    const [selectionMode, setSelectionMode] = useState('all'); // 'all' = send to all (minus exclusions), 'custom' = only selected
    const [excludedCompanyIds, setExcludedCompanyIds] = useState(new Set());
    const [selectedCompanyIds, setSelectedCompanyIds] = useState(new Set());
    const [statusTab, setStatusTab] = useState(0); // 0: All, 1: Triggered, 2: Scheduled, 3: Draft
    const [createdByFilter, setCreatedByFilter] = useState('');

    const detailedRecipients = useMemo(() => {
        const recipients = detailedStatsData?.recipients || [];

        return recipients.filter((recipient) => {
            const companyMatches = recipient.company_name?.toLowerCase().includes(detailedRecipientSearch.toLowerCase()) || recipient.email?.toLowerCase().includes(detailedRecipientSearch.toLowerCase());
            if (!companyMatches) return false;

            if (detailedRecipientStatusFilter !== 'all') {
                const statusValue = recipient.initial_status || 'invalid';
                if (detailedRecipientStatusFilter === 'valid' && statusValue !== 'valid') return false;
                if (detailedRecipientStatusFilter === 'invalid' && statusValue === 'valid') return false;
            }

            if (detailedRecipientBouncedFilter !== 'all') {
                const bounced = Boolean(recipient.bounced_at);
                if (detailedRecipientBouncedFilter === 'bounced' && !bounced) return false;
                if (detailedRecipientBouncedFilter === 'not_bounced' && bounced) return false;
            }

            if (detailedRecipientSpamFilter !== 'all') {
                const spam = Boolean(recipient.spam_reported_at);
                if (detailedRecipientSpamFilter === 'spam' && !spam) return false;
                if (detailedRecipientSpamFilter === 'not_spam' && spam) return false;
            }

            return true;
        });
    }, [detailedStatsData, detailedRecipientSearch, detailedRecipientStatusFilter, detailedRecipientBouncedFilter, detailedRecipientSpamFilter]);

    const recipientsByCompany = useMemo(() => {
        const groups = {};
        detailedRecipients.forEach((recipient) => {
            const company = recipient.company_name || 'N/A';
            if (!groups[company]) groups[company] = [];
            groups[company].push(recipient);
        });
        return groups;
    }, [detailedRecipients]);

    // Set default date range to last 8 days
    const getDefaultDateRange = () => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - 8);
        
        return {
            startDate: startDate.toISOString().split('T')[0],
            endDate: endDate.toISOString().split('T')[0]
        };
    };
    
    const [dateRange, setDateRange] = useState(getDefaultDateRange());

    const handleOpenBulkDialog = () => {
        setBulkStages(stageData.map((s) => s.id));
        setIsBulkDialogOpen(true);
    };

    const handleCloseBulkDialog = () => {
        setIsBulkDialogOpen(false);
        setBulkStages([]);
        setBulkDateRange([]);
        setBulkSubject('');
        setBulkBody('');
        setBulkSender('');
        setBulkCountries([]);
        setBulkOutreachStatus('');
        setBulkNewsletterStatus('');
        setBulkInvalidStatus('');
        setIsPreviewDialogOpen(false);
        setActiveStep(0);
        setEditingCampaignId(null);
        setZipFileName('');
        setRecipientCompanies([]);
        setRecipientTotalCount(0);
        setRecipientSearch('');
        setRecipientPage(1);
        setRecipientHasMore(false);
        setExcludedCompanyIds(new Set());
        setSelectedCompanyIds(new Set());
        setSelectionMode('all');
    };

    const getStatusFromTab = (tabIndex) => {
        switch (tabIndex) {
            case 1: return ['triggered'];
            case 2: return ['scheduled'];
            case 3: return ['draft'];
            default: return [];
        }
    };

    const handleStatusTabChange = (event, newValue) => {
        setStatusTab(newValue);
        setCurrentPage(0);
        const statusFilter = getStatusFromTab(newValue);
        setFilterParams(prev => ({
            ...prev,
            status: statusFilter
        }));
    };

    const handleCreatedByChange = (event, value) => {
        setCreatedByFilter(value?.id || '');
        setCurrentPage(0);
        setFilterParams(prev => ({
            ...prev,
            created_by: value?.id ? [value.id] : []
        }));
    };

    const handleDateRangeChange = (field, value) => {
        setDateRange(prev => ({ ...prev, [field]: value }));
        setCurrentPage(0);
        setSelectedDateRange(field === 'startDate' ? [value, dateRange.endDate, 'created'] : [dateRange.startDate, value, 'created']);
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const isStepValid = (step) => {
        switch (step) {
            case 0:
                return bulkSubject.trim() !== '' && bulkBody.trim() !== '';
            case 1:
                return bulkStages.length > 0;
            case 2:
                return bulkSender !== '';
            default:
                return false;
        }
    };

    const handleClearFilters = () => {
        // Reset all filters to default values
        setStatusTab(0);
        setCreatedByFilter('');
        setDateRange({ startDate: '', endDate: '' }); // Clear date range completely
        setSelectedDateRange([]); // Clear selected date range
        setBulkDateRange([]); // Clear bulk date range as well
        setCurrentPage(0);
        setFilterParams(null);
    };

    const handleBulkDateChange = (value) => {
        setBulkDateRange(value);
    };

    const fetchRecipientPreview = useCallback((page = 1, search = '', append = false) => {
        setRecipientLoading(true);
        const params = new URLSearchParams();
        if (bulkStages.length > 0) params.append('stages', bulkStages.join(','));
        if (bulkDateRange[0]) params.append('start_date', bulkDateRange[0]);
        if (bulkDateRange[1]) params.append('end_date', bulkDateRange[1]);
        if (bulkCountries.length > 0) params.append('countries', bulkCountries.join(','));
        if (bulkOutreachStatus) params.append('outreach_status', bulkOutreachStatus);
        if (bulkNewsletterStatus) params.append('newsletter_status', bulkNewsletterStatus);
        if (bulkInvalidStatus) params.append('invalid_status', bulkInvalidStatus);
        if (search) params.append('search', search);
        params.append('page', page);
        params.append('page_size', 20);

        apiInstance.get(`campaigns/preview-recipients/?${params.toString()}`)
            .then((response) => {
                const data = response?.data?.data;
                if (data) {
                    setRecipientTotalCount(data.total_count);
                    if (append) {
                        setRecipientCompanies(prev => [...prev, ...data.companies]);
                    } else {
                        setRecipientCompanies(data.companies || []);
                    }
                    setRecipientPage(data.page);
                    setRecipientHasMore(data.page * data.page_size < data.total_count);
                }
            })
            .catch(() => {})
            .finally(() => setRecipientLoading(false));
    }, [bulkStages, bulkDateRange, bulkCountries, bulkOutreachStatus, bulkNewsletterStatus, bulkInvalidStatus]);

    // Auto-fetch recipients when filters change (debounced)
    useEffect(() => {
        if (!isBulkDialogOpen || activeStep < 1) return;
        if (recipientDebounceRef.current) clearTimeout(recipientDebounceRef.current);
        recipientDebounceRef.current = setTimeout(() => {
            setRecipientSearch('');
            setRecipientPage(1);
            fetchRecipientPreview(1, '');
        }, 400);
        return () => clearTimeout(recipientDebounceRef.current);
    }, [bulkStages, bulkDateRange, bulkCountries, bulkOutreachStatus, bulkNewsletterStatus, bulkInvalidStatus, isBulkDialogOpen, activeStep, fetchRecipientPreview]);

    const handleRecipientSearch = (value) => {
        setRecipientSearch(value);
        if (recipientDebounceRef.current) clearTimeout(recipientDebounceRef.current);
        recipientDebounceRef.current = setTimeout(() => {
            setRecipientPage(1);
            fetchRecipientPreview(1, value);
        }, 400);
    };

    const handleRecipientScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop - clientHeight < 50 && recipientHasMore && !recipientLoading) {
            const nextPage = recipientPage + 1;
            fetchRecipientPreview(nextPage, recipientSearch, true);
        }
    };

    const handleZipUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setIsUploadingZip(true);
        setZipFileName(file.name);
        try {
            const formData = new FormData();
            formData.append('zip_file', file);

            const response = await apiInstance.post('campaigns/upload-newsletter-zip/', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            const processedHtml = response?.data?.data?.html;
            if (processedHtml) {
                setBulkBody(processedHtml);
                showToast(`ZIP processed — ${response?.data?.data?.images_uploaded || 0} images uploaded`, 'success', 5000);
            }
        } catch (err) {
            showErrorToast(err, 'Failed to process ZIP file', 5000);
            setZipFileName('');
        } finally {
            setIsUploadingZip(false);
            if (zipInputRef.current) zipInputRef.current.value = '';
        }
    };

    const handleSaveDraft = () => {
        if (!bulkSubject || !bulkBody) {
            showErrorToast(null, 'Please fill subject and content.');
            return;
        }

        setIsSendingBulk(true);

        const actualRecipientCount = selectionMode === 'custom'
            ? selectedCompanyIds.size
            : recipientTotalCount - excludedCompanyIds.size;

        const payload = {
            campaign_name: bulkSubject,
            subject: bulkSubject,
            body: bulkBody,
            sender_id: bulkSender || undefined,
            stages: bulkStages && bulkStages.length > 0 ? bulkStages.join(',') : '',
            start_date: bulkDateRange[0] || '',
            end_date: bulkDateRange[1] || '',
            countries: bulkCountries && bulkCountries.length > 0 ? bulkCountries.join(',') : '',
            outreach_status: bulkOutreachStatus || '',
            newsletter_status: bulkNewsletterStatus || '',
            invalid_status: bulkInvalidStatus || '',
            excluded_company_ids: selectionMode === 'all' && excludedCompanyIds.size > 0 ? Array.from(excludedCompanyIds).join(',') : '',
            selected_company_ids: selectionMode === 'custom' && selectedCompanyIds.size > 0 ? Array.from(selectedCompanyIds).join(',') : '',
            recipient_count: actualRecipientCount,
        };

        const isEditing = !!editingCampaignId;
        const method = isEditing ? 'patch' : 'post';
        const url = isEditing ? `campaigns/${editingCampaignId}/` : 'campaigns/';

        apiInstance({ method, url, data: payload })
            .then((response) => {
                if (response) {
                    showToast(response?.data?.detail || (isEditing ? 'Draft updated' : 'Draft saved'), 'success', 5000);
                    handleCloseBulkDialog();
                    getStatisticsData(currentPage, rowsPerPage, selectedDateRange, filterParams, sortOrder);
                }
            })
            .catch((error) => {
                showErrorToast(error, null, 5000);
            })
            .finally(() => {
                setIsSendingBulk(false);
            });
    };

    const handleEditCampaign = (campaign) => {
        setEditingCampaignId(campaign.id);
        setBulkSubject(campaign.subject || '');
        setBulkBody(campaign.body || '');
        setBulkSender(campaign.sender_id || '');
        setBulkStages(campaign.filter_stages ? campaign.filter_stages.split(',').map(Number).filter(Boolean) : []);
        setBulkCountries(campaign.filter_countries ? campaign.filter_countries.split(',').map(Number).filter(Boolean) : []);
        setBulkOutreachStatus(campaign.filter_outreach_status || '');
        setBulkNewsletterStatus(campaign.filter_newsletter_status || '');
        setBulkInvalidStatus(campaign.filter_invalid_status || '');
        setBulkDateRange([campaign.filter_start_date || '', campaign.filter_end_date || '', 'created']);
        setZipFileName(campaign.body ? 'Previously uploaded' : '');
        if (campaign.selected_company_ids) {
            const ids = campaign.selected_company_ids.split(',').map(Number).filter(Boolean);
            setSelectedCompanyIds(new Set(ids));
            setExcludedCompanyIds(new Set());
            setSelectionMode('custom');
        } else if (campaign.excluded_company_ids) {
            const ids = campaign.excluded_company_ids.split(',').map(Number).filter(Boolean);
            setExcludedCompanyIds(new Set(ids));
            setSelectedCompanyIds(new Set());
            setSelectionMode('all');
        } else {
            setExcludedCompanyIds(new Set());
            setSelectedCompanyIds(new Set());
            setSelectionMode('all');
        }
        setActiveStep(0);
        setIsBulkDialogOpen(true);
    };

    const handleDeleteCampaign = (campaignId, campaignStatus = null) => {
        let confirmMessage = 'Are you sure you want to delete this campaign?';
        if (campaignStatus === 'draft') {
            confirmMessage = 'Are you sure you want to delete this draft?';
        } else if (campaignStatus === 'scheduled') {
            confirmMessage = 'Are you sure you want to delete this scheduled campaign? This cannot be undone.';
        } else if (campaignStatus === 'triggered') {
            confirmMessage = 'Are you sure you want to delete this sent campaign? This cannot be undone.';
        }

        if (!window.confirm(confirmMessage)) return;

        apiInstance.delete(`campaigns/${campaignId}/`)
            .then((response) => {
                showToast(response?.data?.detail || 'Campaign deleted', 'success', 5000);
                getStatisticsData(currentPage, rowsPerPage, selectedDateRange, filterParams, sortOrder);
            })
            .catch((error) => {
                showErrorToast(error, null, 5000);
            });
    };

    const handleCancelSchedule = (campaignId) => {
        if (!window.confirm('Cancel this scheduled newsletter? It will revert to draft.')) return;

        apiInstance.post(`campaigns/${campaignId}/cancel-schedule/`)
            .then((response) => {
                showToast(response?.data?.detail || 'Schedule cancelled', 'success', 5000);
                getStatisticsData(currentPage, rowsPerPage, selectedDateRange, filterParams, sortOrder);
            })
            .catch((error) => {
                showErrorToast(error, null, 5000);
            });
    };

    const handleRescheduleCampaign = (campaignId) => {
        setScheduleCampaignId(campaignId);
        setScheduleDate('');
        setIsScheduleDialogOpen(true);
    };

    const handleSendCampaign = (campaignId) => {
        if (!window.confirm('Send this newsletter now? This action cannot be undone.')) return;

        apiInstance.post(`campaigns/${campaignId}/send-now/`)
            .then((response) => {
                showToast(response?.data?.detail || 'Campaign sending started', 'success', 5000);
                getStatisticsData(currentPage, rowsPerPage, selectedDateRange, filterParams, sortOrder);
            })
            .catch((error) => {
                showErrorToast(error, null, 5000);
            });
    };

    const handleOpenScheduleDialog = (campaignId) => {
        setScheduleCampaignId(campaignId);
        setScheduleDate('');
        setIsScheduleDialogOpen(true);
    };

    const handleScheduleCampaign = () => {
        if (!scheduleDate) {
            showErrorToast(null, 'Please select a date and time.');
            return;
        }

        apiInstance.post(`campaigns/${scheduleCampaignId}/schedule/`, { scheduled_date: new Date(scheduleDate).toISOString() })
            .then((response) => {
                showToast(response?.data?.detail || 'Campaign scheduled', 'success', 5000);
                setIsScheduleDialogOpen(false);
                setScheduleCampaignId(null);
                getStatisticsData(currentPage, rowsPerPage, selectedDateRange, filterParams, sortOrder);
            })
            .catch((error) => {
                showErrorToast(error, null, 5000);
            });
    };

    return (
        <Page title="Bulk Outreach | CRM">
            <Container maxWidth="xl">
                <h2 align="left" style={{ fontSize: '25px', fontWeight: '800', marginBottom: '30px' }}>Newsletter Details</h2>
                {isLoading ? (
                    <div style={{ padding: '16px', marginTop: "20px" }}>
                        {/* Skeleton for the Table Header */}
                        <div style={{ display: 'flex', marginBottom: '20px' }}>
                            {columns.map((column, colIndex) => (
                                <Skeleton
                                    key={colIndex}
                                    variant="text"
                                    width={'30%'}
                                    style={{ marginRight: '16px' }}
                                    height={50}
                                />
                            ))}
                        </div>
                        {/* Skeletons for the Table Rows */}
                        {Array.from(new Array(rowsPerPage)).map((_, rowIndex) => (
                            <div key={rowIndex} style={{ display: 'flex', marginBottom: '10px' }}>
                                {columns.map((column, colIndex) => (
                                    <Skeleton
                                        key={colIndex}
                                        variant="text"
                                        width={'30%'}
                                        style={{ marginRight: '16px' }}
                                        height={50}
                                    />
                                ))}
                            </div>
                        ))}
                    </div>
                ) : (
                    <>
                        {/* Header with Title and Create Button */}
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
                            {/* Filters Row */}
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
                                {/* Left side filters */}
                                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                    {/* Created By Filter */}
                                    <Autocomplete
                                        sx={{ minWidth: 200 }}
                                        size="small"
                                        options={userData || []}
                                        getOptionLabel={(option) => option.user || ''}
                                        value={userData?.find((u) => u.id ===   createdByFilter) || null}
                                        onChange={handleCreatedByChange}
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        renderInput={(params) => <TextField {...params} label="Created by" />}
                                    />
                                </Box>

                                {/* Right side date filters */}
                                <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                                    <TextField
                                        size="small"
                                        type="date"
                                        label="Start (Created)"
                                        InputLabelProps={{ shrink: true }}
                                        value={dateRange.startDate}
                                        onChange={(e) => handleDateRangeChange('startDate', e.target.value)}
                                    />
                                    <TextField
                                        size="small"
                                        type="date"
                                        label="End (Created)"
                                        InputLabelProps={{ shrink: true }}
                                        value={dateRange.endDate}
                                        onChange={(e) => handleDateRangeChange('endDate', e.target.value)}
                                    />
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={handleClearFilters}
                                        sx={{ 
                                            height: '40px', // Match TextField small size height
                                            minWidth: 'auto',
                                            px: 2,
                                            color: 'green',
                                            borderColor: 'green',
                                            '&:hover': {
                                                borderColor: '#999',
                                                backgroundColor: '#f5f5f5'
                                            }
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </Box>
                            </Box>
                            <Stack spacing={1} direction="row" >                                

                                {/* Status Tabs */}
                                <Tabs
                                    value={statusTab}
                                    onChange={handleStatusTabChange}
                                    sx={{ mb: 2 }}
                                >
                                    <Tab label="All" />
                                    <Tab label="Triggered" />
                                    <Tab label="Scheduled" />
                                    <Tab label="Draft" />
                                </Tabs>

                                <Button
                                    variant="contained"
                                    color="success"
                                    size={matches ? 'small' : 'medium'}
                                    onClick={handleOpenBulkDialog}
                                >
                                    Create newsletter
                                </Button>
                            </Stack>

                        </Stack>


                        {/* Filter Section */}
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 3 }}>
                            {/* Applied Filters Row */}
                            {(createdByFilter || dateRange.startDate || dateRange.endDate) && (
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}>
                                    {createdByFilter && (
                                        <Chip
                                            label={`Created by: ${userData?.find((u) => u.id === createdByFilter)?.user || ''}`}
                                            color="primary"
                                            variant="outlined"
                                            size="small"
                                        />
                                    )}
                                    {dateRange.startDate && (
                                        <Chip
                                            label={`From: ${dateRange.startDate}`}
                                            color="default"
                                            variant="outlined"
                                            size="small"
                                        />
                                    )}
                                    {dateRange.endDate && (
                                        <Chip
                                            label={`To: ${dateRange.endDate}`}
                                            color="default"
                                            variant="outlined"
                                            size="small"
                                        />
                                    )}
                                </Box>
                            )}
                        </Box>

                        <ThemeProvider theme={theme}>
                            <MUIDataTable
                                title=""
                            data={statisticsData?.map(item => {
                                const isDraft = item?.campaign?.status === 'draft' || !item?.campaign?.status;
                                const isScheduled = item?.campaign?.status === 'scheduled';
                                const isFailed = item?.campaign?.status === 'failed';
                                return {
                                id: item?.id,
                                campaign_details: {
                                    campaign_name: item?.campaign?.name,
                                    campaign_subject: item?.campaign?.subject,
                                    sender: item?.campaign?.sender,
                                    campaign_date: item?.campaign?.send_date || item?.campaign?.scheduled_date,
                                    scheduled_date: item?.campaign?.scheduled_date,
                                    recipient_count: item?.campaign?.recipient_count,
                                },
                                campaign_status: item?.campaign?.status,
                                delivered: item?.delivered,
                                invalid_emails: item?.invalid_emails,
                                opens: item?.opens,
                                unique_opens: item?.unique_opens,
                                clicks: item?.clicks,
                                unique_clicks: item?.unique_clicks,
                                created_by: item?.campaign?.created_by,
                                actions: {
                                    isDraft,
                                    isScheduled,
                                    isFailed,
                                    campaignId: item?.campaign?.id,
                                    campaign: item?.campaign,
                                    singlesendId: item?.campaign?.singlesend_id,
                                    statsId: item?.id,
                                }
                            };
                            })}
                            columns={columns}
                            options={options}
                            components={components}
                        />
                    </ThemeProvider>
                    </>
                )}
            </Container>

            {isBulkDialogOpen && (
                <Drawer
                    anchor="right"
                    open={isBulkDialogOpen}
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
                        handleCloseBulkDialog();
                    }}
                    ModalProps={{ disableEscapeKeyDown: true }}
                    PaperProps={{
                        sx: {
                            width: matches ? '100%' : '40%',
                            minWidth: matches ? '100%' : 400,
                        },
                    }}
                >
                    <Box
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            bgcolor: 'background.paper',
                        }}
                    >
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 3, pt: 2, pb: 1 }}>
                            <div></div>
                            <Typography variant={matches ? 'h6' : 'h5'} textAlign='center'>
                                {editingCampaignId ? 'Edit Newsletter' : 'Create Newsletter'}
                            </Typography>
                            <IconButton onClick={handleCloseBulkDialog}>
                                <Close />
                            </IconButton>
                        </Stack>
                        
                        <Box sx={{ px: 3, pb: 3, pt: 1, flex: 1, overflow: 'auto' }}>
                            <Stepper activeStep={activeStep} orientation="vertical">
                                {/* Step 1: Newsletter Content */}
                                <Step>
                                    <StepLabel>Newsletter Content</StepLabel>
                                    <StepContent>
                                        <Stack spacing={2} sx={{ mt: 2 }}>
                                            <TextField
                                                label="Subject *"
                                                fullWidth
                                                value={bulkSubject}
                                                onChange={(e) => setBulkSubject(e.target.value)}
                                                size="small"
                                            />

                                            {/* ZIP Upload Area */}
                                            <Box
                                                sx={{
                                                    border: '2px dashed',
                                                    borderColor: bulkBody ? 'success.main' : 'grey.400',
                                                    borderRadius: 2,
                                                    p: 3,
                                                    textAlign: 'center',
                                                    cursor: 'pointer',
                                                    bgcolor: bulkBody ? 'success.50' : 'grey.50',
                                                    '&:hover': { borderColor: 'primary.main', bgcolor: 'action.hover' },
                                                    transition: 'all 0.2s',
                                                }}
                                                onClick={() => !isUploadingZip && zipInputRef.current?.click()}
                                            >
                                                <input
                                                    type="file"
                                                    accept=".zip"
                                                    ref={zipInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={handleZipUpload}
                                                />
                                                {isUploadingZip ? (
                                                    <Stack alignItems="center" spacing={1}>
                                                        <Typography variant="body2" color="text.secondary">Processing ZIP...</Typography>
                                                    </Stack>
                                                ) : bulkBody ? (
                                                    <Stack alignItems="center" spacing={1}>
                                                        <CheckCircle color="success" sx={{ fontSize: 40 }} />
                                                        <Typography variant="body2" color="success.main" fontWeight={600}>
                                                            {zipFileName || 'Newsletter loaded'}
                                                        </Typography>
                                                        <Typography variant="caption" color="text.secondary">
                                                            Click to replace with a different ZIP
                                                        </Typography>
                                                    </Stack>
                                                ) : (
                                                    <Stack alignItems="center" spacing={1}>
                                                        <CloudUpload sx={{ fontSize: 40, color: 'grey.500' }} />
                                                        <Typography variant="body2" color="text.secondary">
                                                            Upload newsletter ZIP file
                                                        </Typography>
                                                        <Typography variant="caption" color="text.secondary">
                                                            ZIP should contain index.html + image assets
                                                        </Typography>
                                                    </Stack>
                                                )}
                                            </Box>

                                            {/* Inline Preview */}
                                            {bulkBody && (
                                                <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden' }}>
                                                    <Typography variant="caption" sx={{ px: 1, py: 0.5, bgcolor: 'grey.100', display: 'block' }}>Preview</Typography>
                                                    <iframe
                                                        title="Newsletter Preview"
                                                        srcDoc={bulkBody}
                                                        style={{ width: '100%', height: '40vh', border: 'none' }}
                                                        sandbox="allow-same-origin"
                                                    />
                                                </Box>
                                            )}

                                            <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                                                <Button
                                                    variant="outlined"
                                                    onClick={() => setIsPreviewDialogOpen(true)}
                                                    disabled={!bulkSubject || !bulkBody}
                                                >
                                                    Full Preview
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleNext}
                                                    disabled={!isStepValid(0)}
                                                >
                                                    Next
                                                </Button>
                                            </Box>
                                        </Stack>
                                    </StepContent>
                                </Step>

                                {/* Step 2: Filter Companies */}
                                <Step>
                                    <StepLabel>Filter Companies</StepLabel>
                                    <StepContent>
                                        <Stack spacing={2} sx={{ mt: 2 }}>
                                            {/* Stages with checkboxes + Select All */}
                                            <Box>
                                                <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Stages *</Typography>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={stageData.length > 0 && bulkStages.length === stageData.length}
                                                            indeterminate={bulkStages.length > 0 && bulkStages.length < stageData.length}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setBulkStages(stageData.map((s) => s.id));
                                                                } else {
                                                                    setBulkStages([]);
                                                                }
                                                            }}
                                                            size="small"
                                                        />
                                                    }
                                                    label={<Typography variant="body2" fontWeight={600}>Select All</Typography>}
                                                />
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0, ml: 1 }}>
                                                    {stageData.map((stage) => (
                                                        <FormControlLabel
                                                            key={stage.id}
                                                            control={
                                                                <Checkbox
                                                                    checked={bulkStages.includes(stage.id)}
                                                                    onChange={(e) => {
                                                                        if (e.target.checked) {
                                                                            setBulkStages(prev => [...prev, stage.id]);
                                                                        } else {
                                                                            setBulkStages(prev => prev.filter(id => id !== stage.id));
                                                                        }
                                                                    }}
                                                                    size="small"
                                                                />
                                                            }
                                                            label={<Typography variant="body2">{stage.stage}</Typography>}
                                                            sx={{ minWidth: 100 }}
                                                        />
                                                    ))}
                                                </Box>
                                            </Box>
                                            
                                            <Stack direction="row" spacing={2}>
                                                <TextField
                                                    fullWidth
                                                    label="Start Date (Created)"
                                                    type="date"
                                                    InputLabelProps={{ shrink: true }}
                                                    size="small"
                                                    value={bulkDateRange[0] || ''}
                                                    onChange={(e) =>
                                                        setBulkDateRange([
                                                            e.target.value,
                                                            bulkDateRange[1] || '',
                                                            'created',
                                                        ])
                                                    }
                                                />
                                                <TextField
                                                    fullWidth
                                                    label="End Date (Created)"
                                                    type="date"
                                                    InputLabelProps={{ shrink: true }}
                                                    size="small"
                                                    value={bulkDateRange[1] || ''}
                                                    onChange={(e) =>
                                                        setBulkDateRange([
                                                            bulkDateRange[0] || '',
                                                            e.target.value,
                                                            'created',
                                                        ])
                                                    }
                                                />
                                            </Stack>
                                            
                                            {countryData?.length > 0 && (
                                                <Autocomplete
                                                    multiple
                                                    options={countryData || []}
                                                    getOptionLabel={(option) => option.country || ''}
                                                    value={countryData.filter((c) => bulkCountries.includes(c.id))}
                                                    onChange={(event, newValue) => {
                                                        setBulkCountries(newValue.map((item) => item.id));
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Countries"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            )}

                                            {/* Company Status Filters */}
                                            <Stack direction="row" spacing={2}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    label="Outreach Status"
                                                    size="small"
                                                    value={bulkOutreachStatus}
                                                    onChange={(e) => setBulkOutreachStatus(e.target.value)}
                                                >
                                                    <MenuItem value="">All</MenuItem>
                                                    <MenuItem value="outreached">Outreached</MenuItem>
                                                    <MenuItem value="not_outreached">Not Outreached</MenuItem>
                                                </TextField>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    label="Newsletter Status"
                                                    size="small"
                                                    value={bulkNewsletterStatus}
                                                    onChange={(e) => setBulkNewsletterStatus(e.target.value)}
                                                >
                                                    <MenuItem value="">All</MenuItem>
                                                    <MenuItem value="newsletter_only">Marked for Newsletter</MenuItem>
                                                    <MenuItem value="not_newsletter_only">Not Marked for Newsletter</MenuItem>
                                                </TextField>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    label="Invalid Status"
                                                    size="small"
                                                    value={bulkInvalidStatus}
                                                    onChange={(e) => setBulkInvalidStatus(e.target.value)}
                                                >
                                                    <MenuItem value="">All</MenuItem>
                                                    <MenuItem value="invalid">Invalid</MenuItem>
                                                    <MenuItem value="not_invalid">Not Invalid</MenuItem>
                                                </TextField>
                                            </Stack>

                                            {/* Recipient Preview with Selection */}
                                            <Divider />
                                            <Box>
                                                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                                                    <Typography variant="subtitle2">
                                                        Recipients: {recipientLoading && recipientCompanies.length === 0 ? '...' : (
                                                            <strong>
                                                                {selectionMode === 'custom'
                                                                    ? selectedCompanyIds.size
                                                                    : recipientTotalCount - excludedCompanyIds.size
                                                                } of {recipientTotalCount} companies
                                                            </strong>
                                                        )}
                                                    </Typography>
                                                    {recipientTotalCount > 0 && (
                                                        <Chip
                                                            label={`${selectionMode === 'custom' ? selectedCompanyIds.size : recipientTotalCount - excludedCompanyIds.size} will receive`}
                                                            color={selectionMode === 'custom' && selectedCompanyIds.size <= 5 ? 'warning' : 'primary'}
                                                            size="small"
                                                            variant="outlined"
                                                        />
                                                    )}
                                                </Stack>

                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    placeholder="Search companies..."
                                                    value={recipientSearch}
                                                    onChange={(e) => handleRecipientSearch(e.target.value)}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Search fontSize="small" />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    sx={{ mb: 1 }}
                                                />

                                                {/* Select All / Deselect All toggle */}
                                                {recipientTotalCount > 0 && (
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={selectionMode === 'all' && excludedCompanyIds.size === 0}
                                                                indeterminate={selectionMode === 'all' && excludedCompanyIds.size > 0}
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        setSelectionMode('all');
                                                                        setExcludedCompanyIds(new Set());
                                                                        setSelectedCompanyIds(new Set());
                                                                    } else {
                                                                        setSelectionMode('custom');
                                                                        setSelectedCompanyIds(new Set());
                                                                        setExcludedCompanyIds(new Set());
                                                                    }
                                                                }}
                                                                size="small"
                                                            />
                                                        }
                                                        label={<Typography variant="body2" fontWeight={600}>Select All Companies</Typography>}
                                                        sx={{ mb: 0.5 }}
                                                    />
                                                )}

                                                <Box
                                                    ref={recipientListRef}
                                                    onScroll={handleRecipientScroll}
                                                    sx={{
                                                        maxHeight: 200,
                                                        overflow: 'auto',
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: 1,
                                                        bgcolor: '#fafafa',
                                                    }}
                                                >
                                                    {recipientCompanies.length === 0 && !recipientLoading ? (
                                                        <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: 'center' }}>
                                                            {bulkStages.length === 0 ? 'Select at least one stage' : 'No matching companies found'}
                                                        </Typography>
                                                    ) : (
                                                        <List dense disablePadding>
                                                            {recipientCompanies.map((company, idx) => {
                                                                const isChecked = selectionMode === 'all'
                                                                    ? !excludedCompanyIds.has(company.id)
                                                                    : selectedCompanyIds.has(company.id);
                                                                return (
                                                                <ListItem
                                                                    key={`${company.id}-${idx}`}
                                                                    divider
                                                                    sx={{ py: 0.25, cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        if (selectionMode === 'all') {
                                                                            setExcludedCompanyIds(prev => {
                                                                                const next = new Set(prev);
                                                                                if (next.has(company.id)) {
                                                                                    next.delete(company.id);
                                                                                } else {
                                                                                    next.add(company.id);
                                                                                }
                                                                                return next;
                                                                            });
                                                                        } else {
                                                                            setSelectedCompanyIds(prev => {
                                                                                const next = new Set(prev);
                                                                                if (next.has(company.id)) {
                                                                                    next.delete(company.id);
                                                                                } else {
                                                                                    next.add(company.id);
                                                                                }
                                                                                return next;
                                                                            });
                                                                        }
                                                                    }}
                                                                >
                                                                    <Checkbox
                                                                        checked={isChecked}
                                                                        size="small"
                                                                        sx={{ p: 0.5, mr: 1 }}
                                                                    />
                                                                    <ListItemText
                                                                        primary={company.name}
                                                                        secondary={
                                                                            <>
                                                                                {company.email}
                                                                                {company.created_by ? <span style={{ color: '#888', marginLeft: 8 }}>• Added by {company.created_by}</span> : ''}
                                                                            </>
                                                                        }
                                                                        primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                                                                        secondaryTypographyProps={{ variant: 'caption' }}
                                                                    />
                                                                </ListItem>
                                                                );
                                                            })}
                                                            {recipientLoading && (
                                                                <ListItem sx={{ justifyContent: 'center', py: 1 }}>
                                                                    <CircularProgress size={20} />
                                                                </ListItem>
                                                            )}
                                                        </List>
                                                    )}
                                                </Box>
                                            </Box>
                                            
                                            <Box sx={{ mt: 2 }}>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleNext}
                                                    disabled={!isStepValid(1)}
                                                    sx={{ mr: 1 }}
                                                >
                                                    Next
                                                </Button>
                                                <Button onClick={handleBack}>
                                                    Back
                                                </Button>
                                            </Box>
                                        </Stack>
                                    </StepContent>
                                </Step>

                                {/* Step 3: Sender Details */}
                                <Step>
                                    <StepLabel>Sender Details</StepLabel>
                                    <StepContent>
                                        <Stack spacing={2} sx={{ mt: 2 }}>
                                            <TextField
                                                select
                                                label="From *"
                                                fullWidth
                                                value={bulkSender}
                                                onChange={(e) => setBulkSender(e.target.value)}
                                                size="small"
                                            >
                                                {senderDetails?.map((item) => (
                                                    <MenuItem key={item.id} value={item.id} disabled={!item?.is_verified}>
                                                        <Box>
                                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                                {item.sender_name || item.email}
                                                            </Typography>
                                                            {item.sender_name && (
                                                                <Typography variant="caption" color="text.secondary">
                                                                    {item.email}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                            
                                            <Box sx={{ mt: 2 }}>
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    onClick={handleSaveDraft}
                                                    disabled={isSendingBulk || !isStepValid(2)}
                                                    sx={{ mr: 1 }}
                                                >
                                                    {isSendingBulk ? 'Saving...' : (editingCampaignId ? 'Update Draft' : 'Save as Draft')}
                                                </Button>
                                                <Button onClick={handleBack}>
                                                    Back
                                                </Button>
                                            </Box>
                                        </Stack>
                                    </StepContent>
                                </Step>
                            </Stepper>
                        </Box>
                    </Box>
                </Drawer>
            )}
            {isPreviewDialogOpen && (
                <Dialog maxWidth="md" fullWidth open={isPreviewDialogOpen} onClose={() => { setIsPreviewDialogOpen(false); }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 2, pt: 2 }}>
                        <div></div>
                        <Typography variant={matches ? 'h6' : 'h5'} textAlign='center'>Email Preview</Typography>
                        <IconButton onClick={() => { setIsPreviewDialogOpen(false); }}>
                            <Close />
                        </IconButton>
                    </Stack>
                    <DialogContent sx={{ px: 3 }}>
                        <Box mt={1} border="1px solid #e0e0e0" borderRadius={1} sx={{ overflow: 'hidden', height: '60vh' }}>
                            <iframe
                                title="Email Preview"
                                srcDoc={decodeHtml(bulkBody)}
                                style={{ width: '100%', height: '100%', border: 'none' }}
                            />
                        </Box>
                    </DialogContent>
                </Dialog>
            )}

            {/* Schedule Dialog */}
            {isScheduleDialogOpen && (
                <Dialog open={isScheduleDialogOpen} onClose={() => setIsScheduleDialogOpen(false)} maxWidth="xs" fullWidth>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 2, pt: 2 }}>
                        <div></div>
                        <Typography variant="h6" textAlign="center">
                            {statisticsData?.find(item => item?.campaign?.id === scheduleCampaignId)?.campaign?.status === 'failed' 
                                ? 'Reschedule Newsletter' 
                                : 'Schedule Newsletter'}
                        </Typography>
                        <IconButton onClick={() => setIsScheduleDialogOpen(false)}>
                            <Close />
                        </IconButton>
                    </Stack>
                    <DialogContent>
                        <Stack spacing={2} sx={{ mt: 1 }}>
                            <TextField
                                label="Schedule Date & Time"
                                type="datetime-local"
                                fullWidth
                                value={scheduleDate}
                                onChange={(e) => setScheduleDate(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: new Date().toISOString().slice(0, 16) }}
                                helperText={`Timezone: ${Intl.DateTimeFormat().resolvedOptions().timeZone} (your local time)`}
                            />
                            <Button
                                variant="contained"
                                color="warning"
                                onClick={handleScheduleCampaign}
                                disabled={!scheduleDate}
                                startIcon={<Schedule />}
                            >
                                Schedule
                            </Button>
                        </Stack>
                    </DialogContent>
                </Dialog>
            )}
{/* Detailed Stats Drawer */}
{detailedStatsOpen && (
    <Drawer
        anchor="right"
        open={detailedStatsOpen}
        onClose={() => { setDetailedStatsOpen(false); setDetailedStatsData(null); }}
        PaperProps={{
            sx: {
                width: '90vw',
                maxWidth: '1400px',
            },
        }}
    >
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 3, pt: 2, pb: 1 }}>
            <div></div>
            <Typography variant="h5" textAlign="center" fontWeight={600}>
                Campaign Detailed Statistics
            </Typography>
            <IconButton onClick={() => { setDetailedStatsOpen(false); setDetailedStatsData(null); }}>
                <Close />
            </IconButton>
        </Stack>
        <Box sx={{ px: 3, pb: 3, overflow: 'auto', height: 'calc(100vh - 80px)' }}>
            {loadingDetailedStats ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                    <Typography variant="body1" sx={{ ml: 2 }}>Loading detailed statistics...</Typography>
                </Box>
            ) : detailedStatsData ? (
                <Box>
                    {/* Campaign Info - 2x3 Grid */}
                    <Box sx={{ mb: 4, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
                        <Typography variant="body2">
                            <strong>Name:</strong> {detailedStatsData.campaign?.name || 'N/A'}
                        </Typography>
                        <Typography variant="body2">
                            <strong>Subject:</strong> {detailedStatsData.campaign?.subject || 'N/A'}
                        </Typography>
                        <Typography variant="body2">
                            <strong>Status:</strong>{' '}
                            <Chip 
                                label={detailedStatsData.campaign?.status || 'N/A'} 
                                color={detailedStatsData.campaign?.status === 'triggered' ? 'success' : 'default'}
                                size="small"
                            />
                        </Typography>
                        <Typography variant="body2">
                            <strong>Created:</strong> {detailedStatsData.campaign?.created ? new Date(detailedStatsData.campaign.created).toLocaleString() : 'N/A'}
                        </Typography>
                        <Typography variant="body2">
                            <strong>Send Date:</strong> {detailedStatsData.campaign?.send_date ? new Date(detailedStatsData.campaign.send_date).toLocaleString() : 'N/A'}
                        </Typography>
                        <Typography variant="body2">
                            <strong>Invalid Emails:</strong> <span style={{ color: '#d32f2f', fontWeight: 600 }}>{detailedStatsData.summary?.invalid_emails || 0}</span>
                        </Typography>
                    </Box>

                    {/* Recipients Table */}
                    <Box>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="h6" fontWeight={600}>
                                Recipients ({detailedStatsData.recipients?.length || 0})
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
                            <TextField
                                size="small"
                                label="Search company/email"
                                value={detailedRecipientSearch}
                                onChange={(e) => setDetailedRecipientSearch(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search fontSize="small" />
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <TextField
                                size="small"
                                select
                                label="Status"
                                value={detailedRecipientStatusFilter}
                                onChange={(e) => setDetailedRecipientStatusFilter(e.target.value)}
                                sx={{ minWidth: 150 }}
                            >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="valid">Valid</MenuItem>
                                <MenuItem value="invalid">Invalid</MenuItem>
                            </TextField>

                            <TextField
                                size="small"
                                select
                                label="Bounced"
                                value={detailedRecipientBouncedFilter}
                                onChange={(e) => setDetailedRecipientBouncedFilter(e.target.value)}
                                sx={{ minWidth: 150 }}
                            >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="bounced">Bounced</MenuItem>
                                <MenuItem value="not_bounced">Not Bounced</MenuItem>
                            </TextField>

                            <TextField
                                size="small"
                                select
                                label="Spam"
                                value={detailedRecipientSpamFilter}
                                onChange={(e) => setDetailedRecipientSpamFilter(e.target.value)}
                                sx={{ minWidth: 150 }}
                            >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="spam">Spam</MenuItem>
                                <MenuItem value="not_spam">Not Spam</MenuItem>
                            </TextField>
                        </Box>

                        <TableContainer component={Paper} sx={{ maxHeight: '55vh', overflow: 'auto' }}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: theme.palette.grey[100] }}>
                                        <TableCell sx={{ fontWeight: 600, border: '1px solid #e0e0e0' }}>Company</TableCell>
                                        <TableCell sx={{ fontWeight: 600, border: '1px solid #e0e0e0' }}>Email</TableCell>
                                        <TableCell sx={{ fontWeight: 600, border: '1px solid #e0e0e0' }}>Status</TableCell>
                                        <TableCell sx={{ fontWeight: 600, border: '1px solid #e0e0e0' }}>Opens</TableCell>
                                        <TableCell sx={{ fontWeight: 600, border: '1px solid #e0e0e0' }}>Clicks</TableCell>
                                        <TableCell sx={{ fontWeight: 600, border: '1px solid #e0e0e0' }}>Bounced</TableCell>
                                        <TableCell sx={{ fontWeight: 600, border: '1px solid #e0e0e0' }}>Spam Reported</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.entries(recipientsByCompany).length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={7} sx={{ textAlign: 'center', py: 4 }}>
                                                No recipients found for current filters.
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        Object.entries(recipientsByCompany).sort(([a], [b]) => a.localeCompare(b)).map(([company, recipients]) => (
                                            recipients.map((recipient, index) => (
                                                <TableRow key={`${company}-${recipient.email}-${index}`}>
                                                    {index === 0 ? (
                                                        <TableCell
                                                            rowSpan={recipients.length}
                                                            sx={{
                                                                fontWeight: 600,
                                                                border: '1px solid #e0e0e0',
                                                                backgroundColor: theme.palette.grey[50],
                                                                verticalAlign: 'top',
                                                            }}
                                                        >
                                                            {company}
                                                        </TableCell>
                                                    ) : null}
                                                    <TableCell sx={{ border: '1px solid #e0e0e0' }}>{recipient.email || 'N/A'}</TableCell>
                                                    <TableCell sx={{ border: '1px solid #e0e0e0', textAlign: 'center' }}>
                                                        {recipient.initial_status === 'valid' ? (
                                                            <Chip
                                                                label="Valid"
                                                                size="small"
                                                                color="success"
                                                            />
                                                        ) : (
                                                            <Typography variant="body2">-</Typography>
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={{ border: '1px solid #e0e0e0', textAlign: 'center' }}>
                                                        <Typography variant="body2">
                                                            {recipient.opens_count || 0}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ border: '1px solid #e0e0e0', textAlign: 'center' }}>
                                                        <Typography variant="body2">
                                                            {recipient.clicks_count || 0}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                                        {recipient.bounced_at ? (
                                                            <Tooltip title={recipient.bounce_reason || 'Bounced'}>
                                                                <Typography variant="body2" sx={{ cursor: 'pointer' }}>
                                                                    {new Date(recipient.bounced_at).toLocaleString()}
                                                                </Typography>
                                                            </Tooltip>
                                                        ) : (
                                                            <Typography variant="body2">No</Typography>
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                                        {recipient.spam_reported_at ? new Date(recipient.spam_reported_at).toLocaleString() : 'No'}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            ) : (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                    <Typography variant="body1" color="text.secondary">No data available</Typography>
                </Box>
            )}
        </Box>
    </Drawer>
)}
        </Page>
    )
}
